import React, { FC } from 'react'

import { css, cx } from '@linaria/core'
import { FormattedMessage } from 'react-intl'

import { VoidHandler } from 'common/types'
import { MenuIcon } from 'components/designSystem/MenuIcon/MenuIcon'
import { ExclamationMarkSvg } from 'components/designSystem/svgr/ExclamationMarkSvg'
import { ShareSvg } from 'components/designSystem/svgr/ShareSvg'

export const StareShareComplaint: FC<{
  onComplainsClick: VoidHandler
  onShareClick: VoidHandler
}> = ({ onComplainsClick, onShareClick }) => {
  return (
    <>
      <MenuIcon
        className={cx(menuCss)}
        hasBackground={true}
        onClick={onShareClick}
        icon={<ShareSvg />}
        text={
          <FormattedMessage
            id="form.button.share"
            defaultMessage="Поделиться"
          />
        }
        fontSize={16}
        fontWeight={500}
        tag="div"
        data-name="shares-list-action"
      />
      <MenuIcon
        className={cx(menuCss)}
        hasBackground={true}
        onClick={onComplainsClick}
        icon={<ExclamationMarkSvg />}
        text={
          <FormattedMessage
            id="complaint.title"
            defaultMessage="Пожаловаться"
          />
        }
        fontSize={16}
        fontWeight={500}
        tag="div"
        data-name="complaints-list-action"
      />
    </>
  )
}

const menuCss = css`
  padding: var(--spacing-16px) 0;
  cursor: pointer;
`
